enum MenuEnum {
  MarketManagement = "marketManagement",
  Administration = "administration",
  Mobile = "mobile",
}

export default MenuEnum;
